import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Tournaments from './components/Tournaments';
import Footer from './components/Footer';
import RegistrationModal from '../../components/feature/RegistrationModal';

export default function HomePage() {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-950">
      <Header onJoinClick={() => setIsRegistrationOpen(true)} />
      <Hero onJoinClick={() => setIsRegistrationOpen(true)} />
      <Features />
      <Tournaments />
      <Footer />
      <RegistrationModal 
        isOpen={isRegistrationOpen} 
        onClose={() => setIsRegistrationOpen(false)} 
      />
    </div>
  );
}
